/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { Dispatch, SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import Tooltip from "@/components/Tooltip/Tooltip";
import Typography from "@mui/material/Typography";

import { ChevronRightIcon, colors } from "@dotnet/telematics-design-system";

import { StatusSummaryType } from "../../types";

interface DeactivatedVehiclesButtonProps {
  summary: StatusSummaryType;
  setShowSingleStatusInfo: Dispatch<SetStateAction<StatusSummaryType | null>>;
}

const DeactivatedVehiclesButton = ({
  summary,
  setShowSingleStatusInfo
}: DeactivatedVehiclesButtonProps) => {
  const { t } = useTranslation();

  const handleElementClick = (e: any) => {
    setShowSingleStatusInfo(summary);
  };

  return (
    <Tooltip
      onClick={handleElementClick}
      title={t(`Dashboard##tooltip##click to expand`)}
      placement="top"
      size="medium"
      hasArrow
    >
      <div
        css={css({
          padding: "8px 16px",
          display: "flex",
          background: colors.gray50,
          cursor: "pointer",
          "&:hover": {
            backgroundColor: colors.gray100
          },
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "8px",
          border: `1px solid ${colors.gray200}`
        })}
      >
        <Typography
          variant="body2Medium"
          component="div"
          css={css({
            display: "flex",
            gap: "4px"
          })}
        >
          <span>{t("Filter##deactivatedVehicles")}:</span>
          <span>{summary.count}</span>
        </Typography>

        <ChevronRightIcon style={{ width: "16px", height: "16px" }} />
      </div>
    </Tooltip>
  );
};

export default DeactivatedVehiclesButton;
